import Vue from 'vue'
//该指令使值格式化成"#,##0.00##"，为空或不存在时显示'0.00'
Vue.directive('title', {
    inserted: function(el) {
        document.title = el.getAttribute('title')
    }
})


Vue.directive('copy', {
    bind: function(el, binding) {
        el.$copy = function() {
            const textarea = document.createElement('textarea');
            textarea.value = binding.value;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('Copy');
            document.body.removeChild(textarea);
        }
        el.addEventListener('click', el.$copy);
    },
    unbind: function(el) {
        el.removeEventListener('click', el.$copy);
    }
});



// WEBPACK FOOTER //
// ./src/common/js/filter/directive.js